import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { IEducationSubject } from "../models/education";

@Injectable({
  providedIn: "root",
})
export class EducationSubjectService {
  public list: IEducationSubject[] = [];

  private baseurl: string = "/education-subject";

  constructor(public _httpClient: HttpClient) {}

  async getList() {
    return this._httpClient
      .get(this.baseurl)
      .toPromise()
      .then((response: IEducationSubject[]) => {
        this.list = response;
        return response;
      })
      .catch((err) => {
        console.error(err);
        return [];
      });
  }

  async delete(id: number) {
    return this._httpClient
      .delete(this.baseurl + "/" + id)
      .toPromise()
      .then(async (response) => {
        await this.getList();
        return response;
      });
  }

  async create(data: IEducationSubject) {
    return this._httpClient
      .post(this.baseurl, data)
      .toPromise()
      .then(async (response) => {
        await this.getList();
        return response;
      });
  }

  async update(id: number, data: IEducationSubject) {
    return this._httpClient
      .put(this.baseurl + "/" + id, data)
      .toPromise()
      .then(async () => {
        await this.getList();
      });
  }
}
